import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-circle-angle-right-lined",
  "use": "rt-base-circle-angle-right-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-circle-angle-right-lined\"><path d=\"M657.4 501.5L441.8 314.9c-8-6.9-19.8-0.7-19.8 10.5v373.2c0 11.2 11.8 17.4 19.8 10.5l215.6-186.6c6.1-5.3 6.1-15.7 0-21z\" /><path d=\"M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/circle-angle-right-lined.svg
// module id = 1652
// module chunks = 228